import { render, staticRenderFns } from "./RolesTab.vue?vue&type=template&id=2813323a&"
import script from "./RolesTab.vue?vue&type=script&lang=js&"
export * from "./RolesTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports